import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class MonitorApi extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'ITG';
  controllerName = 'monitors';
  async push(params) {
    let request = {
      url: this.getAPIUrl(),
      data: params,
    };

    return httpClient.postAsync(request);
  }
}
export default new MonitorApi();
